import { createSelector } from '@ngrx/store';
import * as fromVehiclePhoto from '../reducers/vehicle-photo.reducer';
import { getVehiclePhotosState } from '../reducers';

export const getVehiclePhotos = () =>
  createSelector(getVehiclePhotosState, fromVehiclePhoto.getVehiclePhotos);

export const getVehiclePhotosLoading = () =>
  createSelector(
    getVehiclePhotosState,
    fromVehiclePhoto.getVehiclePhotosLoading,
  );

export const getPhotoPlaceholders = () =>
  createSelector(getVehiclePhotosState, fromVehiclePhoto.getPhotoPlaceholders);
